// extracted by mini-css-extract-plugin
module.exports = {"header":"header--YQLGe_INDa","empty-list":"empty-list--IIQ5GOkbUV","emptyList":"empty-list--IIQ5GOkbUV","label":"label--2blB9mv_6Q","loader":"loader--2ZckTnVBsu"};